import { AfterViewInit, ChangeDetectorRef, ViewChild, Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-transfer-game',
  templateUrl: './transfer-game.component.html',
  styleUrls: ['./transfer-game.component.scss']
})
export class TransferGameComponent implements AfterViewInit {
  public company_uuid;

  @ViewChild("table", { static: false }) tb: TableComponent;

  constructor(private http: HttpService, private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();
   }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/transfer/game/get', data: {page_nat: true}},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Title', type: 'string', key: 'title', filter: 'string'}, 
          {label: 'Status', type: 'status', key: 'status', filter: 'status'}, 
          {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/transfer-game-setting/form', hide: true},
          {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_game', title: 'title', hide: true},
        ]}
    this.tb.init(setting);
    this.cdr.detectChanges();
  }

}
